import { EvaluationTimeSlot } from 'domains/calendars/v3/useEvaluationCalendarSummary';
import { z } from 'zod';

/** Simplified since we don't really have to validate EVERY field, we basically just want to know if its undefined or not and cast
 * the type to our existing type. This is because fields aren't manually entered by the user individually but programmatically as a whole object
 */
const TimeSlotSchema = z
  .object(
    {
      time: z.date(),
    },
    {
      message: 'Please choose a time slot',
    },
  )
  .passthrough()
  .transform(d => d as EvaluationTimeSlot);

export const baseSchema = z.object({
  timeZone: z.string(),
});

export const SingleEvaluationSchema = baseSchema.extend({
  type: z.literal('single'),
  timeSlot: TimeSlotSchema,
});

export const SplitEvaluationSchema = baseSchema.extend({
  type: z.literal('split'),
  firstTimeSlot: TimeSlotSchema,
  secondTimeSlot: TimeSlotSchema.optional(),
});

export const EvaluationScheduleSchema = z.discriminatedUnion('type', [SingleEvaluationSchema, SplitEvaluationSchema]);

export type SingleEvaluationSchemaType = z.infer<typeof SingleEvaluationSchema>;
export type SplitEvaluationSchemaType = z.infer<typeof SplitEvaluationSchema>;
export type EvaluationScheduleFormType = z.infer<typeof EvaluationScheduleSchema>;
